/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('KarteiCtrl', ['$rootScope', '$scope', '$http', 'IntentService', 'NetworkService','$timeout', function ($rootScope, $scope, $http, IntentService, NetworkService,$timeout) {


        $scope.history = new History();
        $scope.karteiIsLoaded = false;
        fields = {}
        if (EventId != undefined)
        {
            fields["event"] = EventId
            $scope.eventid = EventId
        }

        NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })



        $scope.getDate = function (d)
        {
            console.log(d)
            var strStart = ""
            try
            {
                var t = d.split(/[- :]/);
                var start = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                strStart = start.getFullYear() + "-" + start.getMonth() + "-" + start.getDate();
            } catch (Exception) {

            }

            return strStart;
        }
        $scope.goBack = function () {
            $scope.history.goBack()
        }

        $scope.calcDayDiff = function (date)
        {

            var d = new Date()
            var t = date.split(/[- :]/);

// Apply each element to the Date function
            var a = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            var seconds = Math.round((d - a) / 1000);
            var days = Math.round(seconds / 60 / 60 / 24);
            return days;
        }

        $scope.evalCommand = function (d)
        {
            alert()
            if ($scope.searchModel == undefined)
            {
                //$scope.updateFilteredPersons()
            } else
            {
                line = $scope.searchModel.split(":")
                console.log(line)
                command = line[0]
                pars = line[1]
                if (command == "event")
                {
                    console.log(command)
                    console.log(pars)
                    if (pars == " *")
                    {
                        $scope.updateFilteredPersons()
                    } else
                    {
                        $scope.updateFilteredPersons(pars)
                    }
                    $scope.searchModel = ""
                }
            }


        }

        $scope.openMitarbeiter = function (id, command)
        {
            var item = {command: command}
            IntentService.setIntent(item)
            window.location.replace("Mitarbeiter.php?maId=" + id)
        }

        $scope.updateFilteredPersons = function (event)
        {
            alert()
            $scope.eventid = event;
            $scope.history.add(window.location.replace.bind(window.location), window.location.href)
            $(".backButton").css("display", "block")

            if (event != undefined)
            {
                fields["event"] = event
            }


            NetworkService.getMitarbeiter(function (data) {
                $scope.mitarbeiter = data
                //console.log(data.data)
            });
        }
        NetworkService.getMitarbeiter(function (data) {
            $scope.mitarbeiter = data
            $timeout(function () {
                var ind = 1
                /*$(".mitarbeiterCard").each(function (id, el) {
                    setTimeout(function () {
                        $(el).velocity({
                            opacity: "1"
                        }, {duration: 100,
                            easing: "ease-in"
                        })
                    }, 100 * (ind/2))

                    ind++
                })*/
                /*$scope.news.forEach(function(el){
                 $timeout(function(){
                 el.show = true;
                 },ind*100)
                 ind++
                 })*/
            }, 100)
            $scope.karteiIsLoaded = true;
            //console.log(data.data)
        });


    }])
